<section class="content">
    <div class="container-fluid pl-0 pr-0">
        <div class="block-header">
            <div class="row">
                <div class="col-12 mt-2">
                    <mat-button-toggle-group aria-label="Font Style" class="" (change)="changeButtonToggle($event)" [value]="selectedOption">
                        <mat-button-toggle value="Internal">L&T Members</mat-button-toggle>
                        <mat-button-toggle value="External">Other Members</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
            </div>
        </div>
        <div [ngClass]="{'kgrid-fullscreen' : enableFullscreen }">
            <kendo-grid #grdMemberList [kendoGridBinding]="memberList" [sortable]="true" [resizable]="true" [filterable]="enableFilter" [reorderable]="true" [pageSize]="15" [pageable]="true" id="grvEDMMemberList" [height]="700">
                <ng-template kendoPagerTemplate>
                    <div class="k-pager-left">
                        <kendo-pager-info></kendo-pager-info>
                    </div>
                    <div class="k-pager-right">
                        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                        <kendo-pager-input></kendo-pager-input>
                        <kendo-pager-next-buttons></kendo-pager-next-buttons>
                    </div>
                </ng-template>
                <ng-template kendoGridToolbarTemplate>
                    <div class="k-grid-toolbar-content d-flex">
                        <div class="flex-grow-1 mat-panel-headerbar"></div>
                        <div style="width:25%;padding-top: 5px;">
                            <form [formGroup]="businessGroupForm" autocomplete="off">
                                <edms-autocomplete [data]="businessGroups" [form]="businessGroupForm" controlName="businessGroup" textField="group_Name" label="Business Group" error="Please select business group" [value]="selectedGroup" (optionSelected)="selectedOrganization($event)"></edms-autocomplete>
                            </form>
                        </div>
                        <div class="divider-container d-none d-md-block" id="imgDivider">
                            <span></span>
                        </div>
                        <div class="pagination-container">
                            <p id="lblShowDetails">Show</p>
                            <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                            </kendo-pager-page-sizes>
                            <span>Items</span>
                        </div>
                        <div class="divider-container d-none d-md-block" id="imgDivider">
                            <span></span>
                        </div>
                        <div class="icons-container">
                            <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                            <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                                <div class="icon-wrap" (click)="toggleFilter()">
                                    <i class="fa fa-filter" title="Filter" aria-hidden="true"></i>
                                    <span class="list-icon-name">Filter</span>
                                </div>
                                <div class="icon-wrap" (click)="toggleFullscreen()">
                                    <i class="fa " [ngClass]="enableFullscreen ? 'fa-compress': ' fa-expand'" aria-hidden="true" title="{{ !enableFullscreen ? 'Expand' : 'Collapse' }}"></i>
                                    <span class="list-icon-name">{{ !enableFullscreen ? 'Expand' : 'Collapse' }}</span>
                                </div>
                            </div>
                            <div class="divider-container"><span></span></div>
                            <i class="fa fa-plus-circle icon-my-10" title="Add Member" aria-hidden="true" (click)="addEditMember()"></i>
                        </div>
                    </div>
                </ng-template>
                <kendo-grid-column title="Sl.No." filterable="false" [width]="60">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                        {{rowIndex+1}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Member" field="member_Name" [width]="200">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.member_Name}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.member_Name}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="PS No" field="staff_PSNo" [width]="150">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.staff_PSNo}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.staff_PSNo}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="ECC Web Login" field="ecc_Web_Login" [width]="150">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.ecc_Web_Login}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.ecc_Web_Login}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Email Id" field="eMail_Id" [width]="150">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.eMail_Id}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.eMail_Id}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Mobile No" field="mobile_No" [width]="130">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{getFormattedMobileNo(dataItem.mobile_No_Prefix, dataItem.mobile_No)}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{getFormattedMobileNo(dataItem.mobile_No_Prefix, dataItem.mobile_No)}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Designation" field="designation" [width]="100">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.designation}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.designation}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Business Group" field="group_Name" [width]="150">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.group_Name}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.group_Name}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Created By" field="created_By" [width]="100">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.created_By}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.created_By}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Created On" field="created_On" [width]="110">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <span class="no-wrap" eipTooltip="{{dataItem.created_On| date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.created_On| date:'dd-MMM-yyyy'}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Modified By" field="modified_By" [width]="100">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.modified_By}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.modified_By}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Modified On" field="modified_On" [width]="110">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <span class="no-wrap" eipTooltip="{{dataItem.modified_On| date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.modified_On| date:'dd-MMM-yyyy'}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Action" [width]="100">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                        <i class="fa fa-pencil icon-my-10 eip-link" style="font-size: 1.25em; cursor: pointer;" (click)="addEditMember(dataItem)" aria-hidden="true"  title="Edit Member" id="btnEDMEdit"></i>
                        <ng-container *ngIf="unlock(dataItem)">
                            <i class="fa fa-unlock icon-my-10 eip-link" style="font-size: 1.25em; cursor: pointer;margin-left: 3% !important;" (click)="UnlockMember(dataItem)" aria-hidden="true" title="Unlock"></i>
                        </ng-container>
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid>
        </div>
    </div>
</section>